import PropTypes from 'prop-types';
import AddressPropType from './AddressPropType';
import EmailPropType from './EmailPropType';
import PhonePropType from './PhonePropType';
import SocialPropType from './SocialPropType';

const DonorUserPropType = {
  addresses: PropTypes.arrayOf(PropTypes.shape(AddressPropType)),
  created: PropTypes.string,
  deleted: PropTypes.bool,
  displayName: PropTypes.string,
  emails: PropTypes.arrayOf(PropTypes.shape(EmailPropType)),
  firstName: PropTypes.string,
  label: PropTypes.string,
  lastName: PropTypes.string,
  ownerOrgId: PropTypes.string,
  phones: PropTypes.arrayOf(PropTypes.shape(PhonePropType)),
  updated: PropTypes.string,
  userId: PropTypes.string,
  ...SocialPropType,
};

export default DonorUserPropType;
